// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --kr-mobile-width: 960px;
  --kr-tablet-width: 1200px;
  --ui-grid-breakpoint: 768px;
  --kr-max-content-width: 1156px;
}

.kb-labfront.container .breadcrumbs {
  z-index: 1;
  display: flex;
  direction: rtl;
  flex-direction: row;
  min-width: 0;
  justify-content: flex-end;
}
.kb-labfront.container .breadcrumbs > .crumb {
  text-overflow: ellipsis;
  min-width: 0;
  max-width: 50%;
  overflow: hidden;
  white-space: nowrap;
  direction: rtl;
  text-align: left;
  direction: rtl;
}
.kb-labfront.container .breadcrumbs > a.crumb, .kb-labfront.container .breadcrumbs > a.crumb:hover {
  text-decoration: underline;
}
.kb-labfront.container .breadcrumbs > a.crumb:hover {
  color: #c7cd04;
}
.kb-labfront.container .breadcrumbs > a.crumb:hover svg .house {
  fill: #c7cd04;
}
.kb-labfront.container .breadcrumbs > a.crumb:hover:after {
  color: #fff;
}
.kb-labfront.container .breadcrumbs > .crumb {
  display: block;
  flex: 0 0 auto;
}
.kb-labfront.container .breadcrumbs > .crumb.home svg {
  position: relative;
  top: 1px;
}
.kb-labfront.container .breadcrumbs > .crumb.home svg .house {
  fill: #fff;
}
.kb-labfront.container .breadcrumbs > .crumb:after {
  content: ">";
  display: inline-block;
  margin: 0 10px;
}
.kb-labfront.container .breadcrumbs > .crumb:last-child::after {
  display: none;
}
.kb-labfront.container .breadcrumbs.light-theme > .crumb.home svg .house {
  fill: #000;
}`, "",{"version":3,"sources":["webpack://./src/styling/_kr.scss","webpack://./src/components/pageElements/Breadcrumbs/Breadcrumbs.scss","webpack://./src/styling/_kr_colors.scss"],"names":[],"mappings":"AAiBA;EACE,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;AChBF;;AAFE;EACE,UAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;AAKJ;AAJI;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAMN;AAJI;EAEE,0BAAA;AAKN;AAHI;EACE,cCbE;ADkBR;AAJM;EACE,aCfA;ADqBR;AAJM;EACE,WAAA;AAMR;AAHI;EACE,cAAA;EACA,cAAA;AAKN;AAJM;EACE,kBAAA;EACA,QAAA;AAMR;AALQ;EACE,UAAA;AAOV;AAJM;EACE,YAAA;EACA,qBAAA;EACA,cAAA;AAMR;AAJM;EACE,aAAA;AAMR;AADQ;EACE,UAAA;AAGV","sourcesContent":["@forward 'kr_colors';\n@forward 'semantic_ui_overrides';\n@forward 'labrador_overrides';\n\n// Maximum page size\n$max_content_width: 1156px;\n\n// Minimum left/right padding\n$min_content_gutter: 22px;\n\n// Minimum left/right padding\n$ui-grid-breakpoint: 768px;\n\n// Breakpoints\n$mobile_width: 960px;\n$tablet_width: $max_content_width + ( 2 * $min_content_gutter ); // 1200 px\n\n:root {\n  --kr-mobile-width: #{$mobile-width};\n  --kr-tablet-width: #{$tablet-width};\n  --ui-grid-breakpoint: #{$ui-grid-breakpoint};\n  --kr-max-content-width: #{$max_content_width};\n}\n\n@mixin max-page-dim {\n  position: relative;\n  max-width: $max_content_width;\n  margin: 0 auto;\n  @media ( max-width: $tablet-width ) {\n    padding-left: $min_content_gutter;\n    padding-right: $min_content_gutter;\n    &.no-gutter {\n      padding-left: 0;\n      padding-right: 0;\n      @media ( min-width: 748px ) and ( max-width: ( $max_content_width + ( $min_content_gutter * 2 ) ) ) {\n        padding-left: $min_content_gutter;\n        padding-right: $min_content_gutter;\n      }\n    }\n  }\n}\n","@use '/src/styling/kr';\n\n.kb-labfront.container {\n  .breadcrumbs {\n    z-index: 1;\n    display: flex;\n    direction: rtl;\n    flex-direction: row;\n    min-width: 0;\n    justify-content: flex-end;\n    & > .crumb {\n      text-overflow: ellipsis;\n      min-width: 0;\n      max-width: 50%;\n      overflow: hidden;\n      white-space: nowrap;\n      direction: rtl;\n      text-align: left;\n      direction: rtl;\n    }\n    & > a.crumb,\n    & > a.crumb:hover {\n      text-decoration: underline;\n    }\n    & > a.crumb:hover {\n      color: kr.$green;\n      svg .house {\n        fill: kr.$green;\n      }\n      &:after {\n        color: #fff;\n      }\n    }\n    & > .crumb {\n      display: block;\n      flex: 0 0 auto;\n      &.home svg {\n        position: relative;\n        top: 1px;\n        .house {\n          fill: #fff;\n        }\n      }\n      &:after {\n        content: \">\";\n        display: inline-block;\n        margin: 0 10px;\n      }\n      &:last-child::after {\n        display: none;\n      }\n    }\n    &.light-theme > .crumb {\n      &.home svg {\n        .house {\n          fill: #000;\n        }\n      }\n    }\n  }\n}","$black: #000000;\n$white: #ffffff;\n$semi-transparent-white: #ffffff22;\n\n$blue: #003662;\n$blue-light: #285274;\n$blue-bright: #e7f5ff;\n$blue-links: #0296ff;\n\n$red: #e52330;\n$red-dark: #940e19;\n\n$green: #c7cd04;\n$green-dark: #9D9f20;\n$green-light: #edf6ea;\n\n$purple-light: #f8f1fa;\n\n$orange-dark: #ff6600;\n$orange-light: #fff4e7;\n\n$tint-editorial: $blue-bright;\n$tint-opinions: $green-light;\n$tint-misc: $purple-light;\n$tint-advertorial: $orange-light;\n\n$link-color: var(--bodytext-link-color);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
